import { ReactNode } from "react";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import LoginWelcome from "../../pages/Login/LoginWelcome";
import Footer from "../Footer";
import HeaderLogin from "../HeaderLogin";

interface Props {
    children: ReactNode;
    title?: string | null
    subTitle?: string | null
}

export default function AuthLayout({ children, title, subTitle }: Props) {

    const { contrastMode } = useAccessibility();

    return (
        <div className={contrastMode ? 'container-login' : 'container-login img-background-login'}>
            <HeaderLogin />
            <div className='container-login-painel'>
                <LoginWelcome />
                <div className='width-100 login-container-end'>{children}</div>
            </div>
            <Footer />
        </div>

    )
}
